import {Image} from "@mui/icons-material";
import BannerCategoriesEdit from "./BannerCategoriesEdit";
import BannerCategoriesList from "./BannerCategoriesList";
import BannerCategoriesCreate from "./BannerCategoriesCreate";

export default {
    list: BannerCategoriesList,
    edit: BannerCategoriesEdit,
    create: BannerCategoriesCreate,
    icon: Image,
};
